module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Weight#1-1f8377b725697689984b5bcaed345e1231d5e5d6e9355d9de9ae8ed038a4d6e0.svg";